
<div class="row">
  @if (type !== DateEditorType.Time) {
    <div class="col-lg-{{ colWidth }}">
      <div class="form-group">
        @if (labelDate) {
          <label class="form-control-label">{{ labelDate | translate}}@if (required) {
            <span class="tx-danger">*</span>
          }</label>
        }
        <span class="t4-date-input-wrapper">
          <input #dateInput [disabled]="disabled" class="form-control" [(ngModel)]="dateText" [beforeToday]="beforeToday" datepicker placeholder="{{datePlaceholder | translate}}" (change)="onDateChange($event)">
          <i class="fa-regular fa-calendar t4-date-input-icon"></i>
        </span>
        <!-- <t4-display-validation controlName="StartDate" [form]="form" [messages]="validationMessages"></t4-display-validation> -->
      </div>
    </div>
  }

  @if (type !== DateEditorType.Date) {
    <div class="col-lg-{{ colWidth }}">
      <div class="form-group">
        @if (labelTime) {
          <label class="form-control-label">{{ labelTime | translate}}@if (required) {
            <span class="tx-danger">*</span>
          }</label>
        }
        <input #timeInput [disabled]="disabled" class="form-control" [(ngModel)]="timeText" type="time" placeholder="{{timePlaceholder | translate}}" (change)="onDateChange($event)"/>
      </div>
    </div>
  }
</div>
